import React, { useEffect } from 'react';
import { connect, history } from 'umi';

import '@/pages/dashboard/assets/scss/page/Monetization/revenue.scss';
import CommonPageRender from '../../components/PageContainer/CommonPageRender';
import { PAGE_CONFIG } from './pageConfig';
const reqParams = '/monetization/revenue';
const MonetizationRevenue = (props: any) => {
  const { gameCode, tabId } = props;
  useEffect(() => {
    // 从pc、console的revenue切换过来后，进行处理，不然的话页面路由不会变化
    if (tabId) {
      history.push(`/dashboard/game/${gameCode}/monetization/revenue`);
    }
  }, [tabId]);

  return (
    <CommonPageRender reqParams={reqParams} pageConfigInit={PAGE_CONFIG} />
  );
};

export default connect((state: any) => {
  return {
    serviceData: state.monetization?.data,
    gameCode: state.dashboard?.currentGame?.game_code,
    rainbow: state.dashboard?.rainbow,
  };
})(MonetizationRevenue);
